/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { setSelectedProductChannel } from './setSelectedProductChannel';
import { removeListingVariant } from './helpers/entityAdapter';

export const removeVariantFromChannel = createAsyncThunk(
  'products/removeVariantFromChannel',
  async ({ masterProductId, channelId, listingVariantId }, { dispatch, extra: { sdk, Logger } }) => {
    try {
      await sdk.products.deleteVariant(listingVariantId);
      dispatch(setSelectedProductChannel({ productId: masterProductId, channelId: 'master' }));
      return { masterProductId, channelId, listingVariantId };
    } catch (error) {
      Logger.error(new Error('Error removing variant from channel'), { error }, [
        'RemoveVariantFromChannelFailed',
        { errorMessage: 'Cannot remove variant from channel' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(removeVariantFromChannel.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(removeVariantFromChannel.fulfilled, (state, { payload }) => {
      const { listingVariantId } = payload;
      state.isBusy = false;
      removeListingVariant(state, listingVariantId);
    })
    .addCase(removeVariantFromChannel.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error?.message || 'Cannot remove variant from channel';
    });
};
